import { render } from "./mentorBoardView.vue?vue&type=template&id=7cb296ea"
import script from "./mentorBoardView.vue?vue&type=script&lang=js"
export * from "./mentorBoardView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__